import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let BaseFileInput = class BaseFileInput extends Vue {
    constructor() {
        super(...arguments);
        this.file = null;
    }
    get fileLabel() {
        return this.attachment || this.label;
    }
    get attachment() {
        return this.fileName || this.currentFile;
    }
    get inputLabel() {
        return !this.attachment ? '' : this.label.replace('\t', '');
    }
    get currentFileUrl() {
        if (this.file) {
            return URL.createObjectURL(this.file);
        }
        return this.fileAttachmentUrl;
    }
    viewFile(fileUrl) {
        window.open(fileUrl);
    }
    onFileChange(file) {
        this.$emit('file:changed', file);
        this.file = file;
    }
};
__decorate([
    Prop({ type: String, default: null })
], BaseFileInput.prototype, "fileName", void 0);
__decorate([
    Prop({ type: String, required: true })
], BaseFileInput.prototype, "label", void 0);
__decorate([
    Prop({ type: String, default: '' })
], BaseFileInput.prototype, "currentFile", void 0);
__decorate([
    Prop({ type: String, default: null })
], BaseFileInput.prototype, "fileAttachmentUrl", void 0);
__decorate([
    Prop({ type: String, default: 'file' })
], BaseFileInput.prototype, "id", void 0);
__decorate([
    Prop({ type: Array, default: null })
], BaseFileInput.prototype, "errorMessages", void 0);
__decorate([
    Prop({ type: String, default: undefined })
], BaseFileInput.prototype, "dataCyInput", void 0);
__decorate([
    Prop({ type: String, default: undefined })
], BaseFileInput.prototype, "dataCyBtn", void 0);
BaseFileInput = __decorate([
    Component
], BaseFileInput);
export default BaseFileInput;
